var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4242_4915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81891 14.5027L4.9835 17.6213L1.93011 17.6859C1.01759 15.9934 0.5 14.057 0.5 11.9992C0.5 10.0093 0.983938 8.13277 1.84175 6.48047H1.84241L4.56078 6.97884L5.75159 9.68091C5.50236 10.4075 5.36652 11.1875 5.36652 11.9992C5.36661 12.88 5.52617 13.724 5.81891 14.5027Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2902 9.75781C24.428 10.4837 24.4999 11.2334 24.4999 11.9996C24.4999 12.8587 24.4095 13.6967 24.2375 14.5051C23.6533 17.2558 22.1269 19.6578 20.0124 21.3576L20.0118 21.3569L16.5878 21.1822L16.1032 18.1572C17.5063 17.3343 18.6028 16.0466 19.1804 14.5051H12.7637V9.75781H19.274H24.2902Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0114 21.3577L20.0121 21.3584C17.9556 23.0113 15.3433 24.0004 12.4996 24.0004C7.92969 24.0004 3.95652 21.4461 1.92969 17.6872L5.81848 14.5039C6.83188 17.2085 9.44089 19.1338 12.4996 19.1338C13.8143 19.1338 15.046 18.7784 16.1029 18.158L20.0114 21.3577Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1596 2.76262L16.2721 5.94525C15.1783 5.26153 13.8853 4.86656 12.5 4.86656C9.37212 4.86656 6.71431 6.88017 5.75169 9.68175L1.84245 6.48131H1.8418C3.83895 2.63077 7.86223 0 12.5 0C15.4117 0 18.0814 1.03716 20.1596 2.76262Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4242_4915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.618d343ae4befc843f5f57b728191745.svg";
export { ForwardRef as ReactComponent };